export {
  vacationHoursApiSlice,
  useGetVacationHoursQuery,
  useGetAvailableVacationHoursQuery,
} from "./vacation-hours";
